// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Translation Management',
  subtitle: 'Manage application translations',
  fileBasedSubtitle: 'File-based translation editor',
  
  // Info messages
  infoText: 'Translations are stored in files under src/locales/ directory.',
  fileBasedInfo: 'File-based Translation System',
  fileBasedInfoHint: 'Edit translations directly in the files. Changes require a page reload to take effect.',
  
  // Language selection
  selectLanguage: 'Select Language',
  
  // Search
  searchTranslations: 'Search translations...',
  
  // File management
  translations: 'translations',
  noTranslationsFound: 'No translations found',
  noFilesFound: 'No translation files found',
  noFilesFoundHint: 'Make sure the locale files exist in src/locales/ directory',
  
  // Edit mode
  editMode: 'Edit Mode',
  viewMode: 'View Mode',
  
  // Save notices
  saveNotice: 'Demo Mode',
  saveNoticeHint: 'In production, this would save the file server-side. For now, check the console for the file content.',
  fileContentReady: 'File content generated! Check console for output.',
  
  // Errors
  loadError: 'Failed to load translations',
  saveError: 'Failed to save translations',
  
  // Actions
  editFile: 'Edit File',
  saveFile: 'Save File',
  cancelEdit: 'Cancel',
  
  // Stats
  totalFiles: 'Total Files',
  totalTranslations: 'Total Translations',
  
  // File categories
  allFiles: 'All Files',
  common: 'Common',
  pages: 'Pages',
  components: 'Components'
};
